import React, { Component } from 'react'
import { Tabs, Row, Col, Form, Input, Button, Spin, Icon, Tooltip, Progress, InputNumber, Upload, message, Modal, Tag, notification} from 'antd';
import { connect } from 'react-redux';
import { getPostCat } from '../../../../core/actions/postGet';
import { editPostCat } from '../../../../core/actions/uploadPost';
import {bindActionCreators} from "redux"
const { TextArea } = Input;

const antIcon = <Icon type="loading" style={{ fontSize: 50 }} spin />

const openNotificationWithIcon = (type, msg, desc) => {
  notification[type]({
    message: msg,
    description: desc,
  });
};


class PostCatUploadEdit extends Component {
  constructor(props) {
    super(props)

    this.state = {
      name: '',
      desc: '',
      loading: false,
      author: '',
      id: ''
    }

    this.handleChange = this.handleChange.bind(this)
  }

  handleChange(e) {
    // console.log(e.target.name,e.target.value)
    this.setState({ [e.target.name]: e.target.value });
  }

  handleSubmit = (e) => {
    e.preventDefault()
    this.props.form.validateFields((err) => {
      if (!err) {
        this.props.editPostCat({
          name: this.state.name || this.props.postcat.name,
          desc: this.state.desc || this.props.postcat.desc,
          author: this.state.author,
          created: this.state.created,
          id: this.state.id
        })
      }
    });
  }  

  componentDidMount() {
    const { slug } = this.props
    if(slug) {
      this.props.getPostCat(slug)
    }
  }

  componentWillReceiveProps(nextProps) {
    // console.log(nextProps)
    const { profile, post, slug, postcat } = nextProps
    // console.log(postcat)
    this.setState({
      author: profile,
      loading: post.loading,
      id: postcat.id,
      created: postcat.created,
      // name: postcat.name,
      // desc: postcat.desc,
    })

    if(postcat) {
      // this.setState({
      //   name: postcat.name,
      //   desc: postcat.desc,
      //   id: postcat.id
      // })
    }
  }

  render() {
    const { getFieldDecorator } = this.props.form;
    const { loading, name, desc } = this.state
    const { postcat } = this.props
    return (
      <div className="catcpost-form">
        <Spin spinning={loading} indicator={antIcon} tip="Creating post category...">
            <Form className="cpost-form" onSubmit={this.handleSubmit}>
            <Form.Item label="Category Name">
              {getFieldDecorator('name', {
                initialValue: postcat.name,
                rules: [{ required: true, message: 'Please input category name' }]
              })(
                <Input
                  name="name"
                  placeholder="Category Name"
                  onChange={(e) => this.handleChange(e)}
                  onFocus={(e) => this.handleChange(e)}
                />
              )}
            </Form.Item>
            <Form.Item label="Category Description">
            {getFieldDecorator('desc', {
                initialValue: postcat.desc,
                rules: [{ required: true, message: 'Please input category description' }]
              })(
                <TextArea
                  onChange={(e) => this.handleChange(e)}
                  placeholder="Category Description"
                  autoSize={{ minRows: 3, maxRows: 5 }}
                  name="desc"
                  onFocus={(e) => this.handleChange(e)}
                />
              )}
            </Form.Item>
            <Form.Item>
              <Button type="primary" htmlType="submit" className="save-btn">
                Edit
              </Button>
            </Form.Item>
          </Form>
        </Spin>
      </div>
    )
  }
}

const WrappedPostCatUploadEdit = Form.create()(PostCatUploadEdit);

const mapStateToProps = state => ({
  profile: state.firebase.profile,
  post: state.post,
  postcat: state.allPosts.postcat
})

const mapDispatchToProps = dispatch => bindActionCreators({
  // uploadPostCat,
  getPostCat,
  editPostCat
},dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(WrappedPostCatUploadEdit);
